var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',{class:_vm.config.cssClasses,attrs:{"href":_vm.config.href,"label":_vm.config.label,"icon":_vm.config.icon,"iconset":_vm.config.iconset},on:{"click":_vm.onClicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }